module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a23892b230c6d987e43994efa487da0a.png";